import React from 'react';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessageSmile } from '@fortawesome/pro-light-svg-icons';

/**
 * The way into the feedback form, pinned to the right edge of the screen.
 *
 * It rests with only its icon showing and slides its label out on hover or
 * focus, so it is reachable from anywhere without standing over the page it is
 * asking about. A touch screen has no hover to finish that with, so there the
 * label is dropped and the icon stands alone — the button says what it is
 * through its label either way.
 *
 * Props:
 *   id      (string)   - ID prefix for generated element IDs.
 *   onClick (function) - Opens the form.
 */
export const FeedbackButton = ({ id = 'feedback', onClick }) => (
  <aside className="mss__feedbackButtonWrapper" id={`${id}__wrapper_button`}>
    <Button
      className="mss__feedbackButton"
      id={`${id}__button_open`}
      aria-label="Got Feedback?"
      onClick={onClick}
      startIcon={<FontAwesomeIcon icon={faMessageSmile} />}
    >
      <span className="feedbackButtonLabel">Got Feedback?</span>
    </Button>
  </aside>
);

export default FeedbackButton;
